export enum EAvatarSize {
    small = "small",
    medium = "medium",
    semi = "semi",
    large = "large",
    extra_large = "extra_large",
}